import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, AbstractControl } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import * as Utils from '@shared/core/utils';
import { isDateValid } from '@shared/core/validators/date.shared.validators';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { Subscription } from 'rxjs';


@Component({
    selector: 'shared-form-for-birthday-rewards',
    templateUrl: './form-for-birthday-rewards.shared.component.html',
    styleUrls: ['./form-for-birthday-rewards.shared.component.scss']
})
export class FormForBirthdayRewardsComponent extends FormTypesComponent implements OnInit, OnDestroy {
    @Input() public modalId!: number;

    private _dayListener$!: Subscription;
    private _monthListener$!: Subscription;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
        public membersService: Services.MembersService,
        public modalsService: Services.ModalsService,
    ) {
        super(config, formBuilder);
        this.formName = 'birthday-rewards';
    }

    ngOnInit(): void {
        this.loading$ = this.controllers.members.isMakingRequestsAsStatus$();
        // Flip & Flap didn't agree to datepicker for unknown reasons ...
        // I'm just leving this code If they come to their senses and figure out
        // that current solution is crippled.
        // this.formControl = this.formBuilder.group({
        //     dateOfBirth: [
        //         { value: '', disabled: false },
        //         {
        //             validators: Validators.compose([
        //                 Validators.required,
        //             ]),
        //         }
        //     ],
        // });
        const maxSignUpYear: number = this.config.minimumAgeToSignUp ? new Date().getFullYear() - this.config.minimumAgeToSignUp : new Date().getFullYear();
        const minSignUpYear: number = this.config.maximumAgeToSignUp ? new Date().getFullYear() - this.config.maximumAgeToSignUp : 1900;

        this.formControl = this.formBuilder.group({
            day: [
                {
                    value: '',
                    disabled: false,

                },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.minLength(1),
                        Validators.maxLength(2),
                        Validators.max(31),
                        Validators.min(1),
                    ])
                }
            ],
            month: [
                {
                    value: '',
                    disabled: false,
                },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.minLength(1),
                        Validators.maxLength(2),
                        Validators.max(12),
                        Validators.min(1),
                    ])
                }
            ],
            year: [
                {
                    value: '',
                    disabled: false,
                },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.minLength(4),
                        Validators.maxLength(4),
                        Validators.min(minSignUpYear),
                        Validators.max(maxSignUpYear),
                        isDateValid(),
                    ])
                }
            ]
        }, {
            updateOn: 'blur'
        });

        this._dayListener$ = this._setFieldListener('day');
        this._monthListener$ = this._setFieldListener('month');
    }

    ngOnDestroy(): void {
        if (this._dayListener$ && !this._dayListener$.closed) this._dayListener$.unsubscribe();
        if (this._monthListener$ && !this._monthListener$.closed) this._monthListener$.unsubscribe();
    }

    private _setFieldListener(fieldName: string): Subscription {
        return this.formControl.get(fieldName).valueChanges.subscribe(() => {
            const field: AbstractControl = this.formControl.get(fieldName);
            if (field.valid) {
                const yearField: AbstractControl = this.formControl.get('year');
                if (yearField.dirty && yearField.value && yearField.value.length === 4) yearField.updateValueAndValidity();
            }
        });
    }

    public handleFormSubmit($event: Event): void {
        const { year, month, day } = this.getFormValues();

        // this.controllers.members.updateMemberProfile({
        //     Birthday: formValues.dateOfBirth._d ? Utils.Dates.getLocalISOFormatDate(formValues.dateOfBirth._d) : null,
        // }, this.modalId);

        const Birthday: string = Utils.Dates.getLocalISOFormatDate(new Date(+year, +month - 1, +day, 12));

        this.controllers.members.updateMemberProfile({
            Birthday,
        }, this.modalId);
    }

    public handleSkipStepClick($event: Event): void {
        this.controllers.members.skipBirthdayRewardsForNow(this.modal === true);
    }

}
